// extracted by mini-css-extract-plugin
module.exports = {"checkCard":"CheckCard_checkCard__8wZyf","cardWrapper":"CheckCard_cardWrapper__174me","selected":"CheckCard_selected__qLxVf"};